import { render, staticRenderFns } from "./AddCodes.vue?vue&type=template&id=5440730d&scoped=true&"
import script from "./AddCodes.vue?vue&type=script&lang=js&"
export * from "./AddCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5440730d",
  null
  
)

export default component.exports